/**
 * Home: arranque temprano de los carruseles con pestañas
 * (sections/collection-tabs-carousel.liquid).
 *
 * Ese carrusel solo se arma (reconstruye las tarjetas y las centra) cuando ocurre
 * el evento "load" de la página, que en móvil tarda mucho porque espera todas las
 * imágenes y el video del hero. Mientras tanto se ve el HTML estático, con la
 * primera tarjeta en otra posición.
 *
 * La sección ya sabe armar un panel cuando se toca su pestaña, así que aquí, en
 * cuanto el HTML está listo (sin esperar a "load"), tocamos la pestaña activa de
 * cada carrusel para que se arme de inmediato. Cuando llega "load", la sección
 * solo re-sincroniza lo que ya está armado. Si algo de esto no aplica, todo sigue
 * funcionando como antes.
 *
 * El CSS que oculta la tira hasta que esté lista está en lov-home.css.
 */
(function () {
  'use strict';

  // El carrusel virtual solo existe en móvil (mismo umbral que la sección)
  if (window.innerWidth > 749) return;

  function start() {
    var panels = document.querySelectorAll('.col-tabs__panel.is-active[data-initialized="false"]');

    panels.forEach(function (panel) {
      var tab = document.querySelector('[data-tab-btn][aria-controls="' + panel.id + '"]');
      if (tab) tab.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
